"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.universalEach = universalEach;

var _dynamicValues = require("@faedev/dynamic-values");

function universalEach(target, callback) {
  if (target instanceof _dynamicValues.DynamicValue) {
    const pureValue = target.value;

    if (Array.isArray(pureValue)) {
      return pureValue.map((valueItem, key) => {
        const change = newValue => {
          const newTarget = [...pureValue];
          newTarget[key] = newValue;
          target.change(newTarget);
        };

        let item;

        if (target instanceof _dynamicValues.FormValue) {
          const pureTouched = target.touched;
          const {
            touch,
            touched
          } = Array.isArray(pureTouched) ? {
            touched: pureTouched[key],
            touch: newValue => {
              const newTouched = [...pureTouched];
              newTouched[key] = newValue;
              target.touch(newTouched);
            }
          } : {
            touched: false,
            touch: newValue => {
              const newTouched = [];
              newTouched[key] = newValue;
              target.touch(newTouched);
            }
          };
          const eachError = target.error ? target.error.each : null;
          item = new _dynamicValues.FormValue(valueItem, change, touched, touch, Array.isArray(eachError) ? eachError[key] : null, target.showErrors, target.setShowErrors);
        } else {
          item = new _dynamicValues.DynamicValue(valueItem, change);
        }

        return callback(item, key);
      });
    } else if (typeof target === "object") {
      return Object.entries(target.value).map(([key, valueItem]) => {
        const change = newValue => {
          if (typeof key === "string") {
            const newTarget = { ...target.value
            };
            newTarget[key] = newValue;
            target.change(newTarget);
          }
        };

        const item = target instanceof _dynamicValues.FormValue ? new _dynamicValues.FormValue(valueItem, change, false, () => {
          throw new Error("iteration touch on map is not implemented yet");
        }, target.error.each[key], target.showErrors, target.setShowErrors) : new _dynamicValues.DynamicValue(valueItem, change);
        return callback(item, key);
      });
    }
  } else {
    if (Array.isArray(target)) {
      return target.map(callback);
    } else if (typeof target === "object" && target) {
      return Object.entries(target).map(([key, item]) => callback(item, key));
    }

    return null;
  }
}
//# sourceMappingURL=universalEach.js.map